<div class="logout-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div
                class="daxa-form ml-auto mr-auto border-radius bg-white"
                [class.card-borderd-theme]="themeService.isCardBorder()"
                [class.component-dark-theme]="themeService.isDark()"
            >
                <div class="title text-center">
                    <h3>
                        iLab
                    </h3>
                </div>
                <div class="admin text-center">

                    <span class="d-block fw-medium">
                        Vous êtes déconnecté avec succés.
                    </span>
                </div>
                <a routerLink="/authentication" mat-button class="btn">
                    Connexion
                </a>
            </div>
        </div>
    </div>
</div>
